import React from 'react';
import {BASE_MODAL_WIDTH} from './constant';
import {tokenRoutes} from '@/app.service';
import globalStore from '@services/global.state';
import {goTo} from '@utils';
import {getUrlParams} from '@components/utils';
import {Linking} from 'react-native';
import {goToUrl} from '@/common-pages/game-navigate';
import {Image} from 'antd-mobile';
import {useSequentialModalContext} from './context';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';

function Promotion(props: {imageUrl: string; openUrl: string}) {
  const {imageUrl, openUrl} = props;
  const {goToNext, onClose} = useSequentialModalContext();
  const handleClick = () => {
    if (openUrl.startsWith('route:')) {
      const [route, popParams] = openUrl.slice(6).split('?');
      const needToken = tokenRoutes.some(r => route.startsWith(r));
      if (!needToken || (needToken && globalStore.token)) {
        goTo(route, getUrlParams(popParams));
      } else {
        goTo('Login', {
          sucessPage: route,
          sucessPageParams: popParams,
        });
      }
    } else if (openUrl.startsWith('http')) {
      Linking.openURL(openUrl);
    } else {
      openUrl && goToUrl(openUrl);
    }
    onClose();
  };
  const {calcActualSize} = useScreenSize();
  const modalWidth = calcActualSize(BASE_MODAL_WIDTH);
  // const modalHeight = calcActualSize(BASE_MODAL_HEIGHT);
  return (
    <div>
      <div onClick={handleClick} className="rounded-lg overflow-hidden">
        <Image
          className="rounded-lg"
          width={modalWidth}
          placeholder={<div></div>}
          fit="cover"
          alt=""
          src={imageUrl}
        />
      </div>

      <Image
        onClick={goToNext}
        className="w-8 h-8 mt-1 absolute -top-11 right-0"
        src={require('@assets/icons/home/button-close.png')}
      />
    </div>
  );
}

export default Promotion;
